// src/i18n.ts
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

// Declare types for i18next resources
declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "translation";
    resources: {
      translation: {
        [key: string]: string; // Allow string keys for translations
      };
    };
  }
}

i18next.use(initReactI18next).init({
  lng: "vi", // Default language
  fallbackLng: "vi", // Fallback language
  interpolation: {
    escapeValue: false, // React handles XSS
  },
});

export default i18next;
